import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import isEqual from 'lodash/isEqual';

import { injectIntl, intlShape } from 'react-intl';
import { bindActionCreators } from 'redux';
import * as CheckoutActions from '../actions/CheckoutActions';
import * as BorrowingActions from '../actions/BorrowingActions';
import ShelfActions from '../actions/ShelfActions';
import RatingsActions from '../actions/RatingsActions';
import { getRatingsTransactions, getRatingsByBibs } from '../selectors/ugc/RatingsSelector';

import {
  currentUserSelector,
  currentAccountSelector
} from '../selectors/AuthSelector';

import { currentLibrarySelector } from '../selectors/LibrarySelector';
import * as CheckoutSelector from '../selectors/CheckoutSelector';
import { getShelfTransactions } from '../selectors/ShelfSelector';
import CheckedOut from '../components/borrowing/checkouts/CheckedOut';
import WorkflowActions from '../actions/WorkflowActions';
import DocumentHeadContainer from './DocumentHeadContainer';
import BasePageContainer from './BasePageContainer';

export class CheckedOutContainer extends BasePageContainer {
  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [
      store.dispatch(BorrowingActions.fetchSummaries({ accountId })),
      store.dispatch(CheckoutActions.fetchCheckouts({ accountId, ...params, ...query }))
    ];
  }

  static getBackToTitleKey() {
    return 'checkedout';
  }

  componentDidMount() {
    super.componentDidMount();

    const { accountId, router, location } = this.props;
    this.props.checkoutActions.fetchCheckouts({ accountId, ...router.params, ...location.query });
  }

  componentWillUpdate(nextProps) {
    const { location, items } = this.props;

    const locationChanged = !isEqual(location, nextProps.location);
    const itemsChanged = !isEqual(items, nextProps.items);

    if (locationChanged || itemsChanged) {
      this.props.checkoutActions.fetchCheckouts({
        accountId: nextProps.accountId,
        ...nextProps.router.params,
        ...nextProps.location.query
      });
    }
  }

  render() {
    const pageTitle = this.props.intl.formatMessage({ id: 'section_title_checkedout' });
    return (
      <div>
        <DocumentHeadContainer pageTitle={pageTitle} />
        <CheckedOut {...this.props} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const library = currentLibrarySelector(state);
  const user = currentUserSelector(state);
  const items = CheckoutSelector.getCurrentCheckouts(state, ownProps);
  const materialTypeCounts = CheckoutSelector.getMaterialTypeCounts(state, ownProps);
  const selectedStatus = CheckoutSelector.getSelectedStatus(state, ownProps);
  const quotas = CheckoutSelector.getCheckedoutQuotas(state, ownProps);
  const featuredListTypes = library.get('featuredListTypes', Immutable.List());
  const showStaffPicksLink = featuredListTypes && featuredListTypes.includes('staff_picks');
  const presentStatuses = CheckoutSelector.getPresentStatuses(state, ownProps);
  const accountId = currentAccountSelector(state).get('id');
  const shelfTransactions = getShelfTransactions(state);
  const checkedoutStatus = CheckoutSelector.getCheckedoutStatus(state);
  const countsByStatus = CheckoutSelector.getCountsByStatus(state);
  const pagination = CheckoutSelector.getPagination(state, ownProps);
  const checkoutTransactions = CheckoutSelector.getCheckoutTransactions(state);
  const ratingsTransactions = getRatingsTransactions(state);
  const ratings = getRatingsByBibs(state);

  return {
    user,
    totalCount: items.size,
    totalUnfilteredCount: selectedStatus ? countsByStatus.get(selectedStatus) : pagination.get('count', 0),
    materialTypeCounts,
    items: items.take(state.getIn(['borrowing', 'checkedout', 'numItemsShowing'])),
    selectedStatus,
    quotas,
    showStaffPicksLink,
    presentStatuses,
    accountId,
    pagination,
    checkoutTransactions,
    shelfTransactions,
    ratingsTransactions,
    ratings,
    fetching: checkedoutStatus.get('fetching', false)
  };
};

const mapDispatchToProps = dispatch => ({
  checkoutActions: bindActionCreators(CheckoutActions, dispatch),
  workflowActions: bindActionCreators(WorkflowActions, dispatch),
  shelfActions: bindActionCreators(ShelfActions, dispatch),
  ratingsActions: bindActionCreators(RatingsActions, dispatch)
});

CheckedOutContainer.propTypes = {
  intl: intlShape,
  checkoutTransactions: ImmutablePropTypes.map,
  shelfTransactions: ImmutablePropTypes.map,
  ratingsTransactions: ImmutablePropTypes.map,
  fetching: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CheckedOutContainer));



// WEBPACK FOOTER //
// ./app/containers/CheckedOutContainer.jsx